import React from 'react'
import { MTableToolbar } from '@material-table/core'
import makeStyles from '@mui/styles/makeStyles'

export function TableToolbar(toolbarProps: {
  children: React.ReactChild
  additionalComponent?: React.ReactChild
}) {
  const classes = useStyles()

  return (
    <div className={classes.toolbar}>
      <MTableToolbar {...toolbarProps} />
      {toolbarProps.additionalComponent
        ? toolbarProps.additionalComponent
        : null}
      {toolbarProps.children}
    </div>
  )
}

export const useStyles = makeStyles((theme) => {
  return {
    toolbar: {
      '& .MuiToolbar-gutters': {
        paddingLeft: theme.spacing(2),
        paddingRight: theme.spacing(2),
      },
    },
  }
})
